import { Navigate, Outlet } from "react-router-dom";
import DashboardLayout from "../layouts/dashboard";
import { useAppRoutes } from "../hooks/useAppRoutes";
import { nurseRoutes } from "./nurse/routes";
import { SettingsDrawer } from "src/components/shared-components/settings";
import { medcardRoutes } from "./medcard/routes";
import ClosableTabs from "src/layouts/dashboard/TabPanel";
import { patientRoutes } from "./patient/routes";
import { isolationRoutes } from "./nurse/isolation/routes";
import { dietProcessRoutes } from "./diet-defination/routes";
import { adminToolsRoutes } from "./admin-tools/routes";
import { surgeryRoutes } from "./surgery/routes";
import NotFoundPage from "src/components/shared-components/error/NotFoundPage";

export default function Router() {
  
  return useAppRoutes([
    
    {
      path: "/",
      element: (
        <DashboardLayout>
          <ClosableTabs />
          <SettingsDrawer />
          <Outlet />
        </DashboardLayout>
      ),
      children: [
        ...nurseRoutes,
        ...medcardRoutes,
        ...patientRoutes,
        ...isolationRoutes,
        ...adminToolsRoutes,
        ...dietProcessRoutes,
        ...surgeryRoutes,
      ],
    },

    // 404 page
    { path: "404", element: <NotFoundPage /> },
    
    // No match - redirect to 404
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
